module.exports = function (messageService) {
    return {
        restrict: 'E',
        scope: {
            inlineMessage: '=',
            onDismiss: '&?'
        },
        link($scope) {
            $scope.dismiss = function ($event) {
                messageService.dismissMessage($scope.inlineMessage);
                if ($scope.onDismiss) {
                    $scope.onDismiss({ event: $event });
                }
            };
        },
        template: require('./inline-message-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/inline-message-directive.js
 **/